import styled from '@emotion/styled';

import Masterplan from './Masterplan';

const ModalMasterplan = styled(Masterplan)({
  maxHeight: '100%',
  cursor: 'zoom-out'
});

export default ModalMasterplan;
